import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="select-modal"
/**
 * <div class="drawer__inner" data-controller="select-modal">
 *   <!-- 絞り込み start -->
 *   <%= search_form_for q, url: path, data: { select_modal_target: 'searchForm' } do |f| %>
 *   <% end %>
 *   <!-- 絞り込み end -->
 *
 *   <!-- チェックボックスの場合 start -->
 *   <table>
 *     <thead>
 *       <input type="checkbox" data-action="select-modal#toggleSubmitButton" />
 *     </thead>
 *     <tbody data-select-modal-target="checkboxList">
 *       <input type="checkbox" data-action="select-modal#toggleSubmitButton" />
 *     </tbody>
 *   </table>
 *   <!-- チェックボックスの場合 end -->
 *
 *   <!-- ラジオボタンの場合 start -->
 *   <table>
 *     <tbody data-select-modal-target="radioButtonList">
 *       <input type="radio" data-action="select-modal#toggleSubmitButton">
 *     </tbody>
 *   </table>
 *   <!-- ラジオボタンの場合 end -->
 *
 *   <%= button_tag '選択する', type: 'submit', data: { action: 'select-modal#disabledSubmitButton', select_modal_target: 'submitButton' } %>
 * </div>
 */
export default class extends Controller {
  static targets = ["checkboxList", "radioButtonList", "submitButton", "searchForm"];

  initialize() {
    this.mutationObserver = new MutationObserver(() => {
      this.toggleSubmitButton();
    });
  }

  connect() {
    this.toggleSubmitButton();
    if (this.hasSearchFormTarget) {
      this.handleSubmitEnd = this.disableSubmitButton.bind(this);
      this.searchFormTarget.addEventListener("turbo:submit-end", this.handleSubmitEnd);
    }
  }

  disconnect() {
    if (this.hasSearchFormTarget) {
      this.searchFormTarget.removeEventListener("turbo:submit-end", this.handleSubmitEnd);
    }
  }

  checkboxListTargetConnected(target) {
    this.mutationObserver.observe(target, { subtree: true, attributes: true, attributeFilter: ["disabled"] });
  }

  toggleSubmitButton() {
    const isChecked = this.hasChecked();
    this.updateSubmitButtonState(isChecked);
  }

  disableSubmitButton() {
    this.updateSubmitButtonState(false);
  }

  disabledSubmitButton(...args) {
    this.disableSubmitButton(...args);
  }

  updateSubmitButtonState(isChecked) {
    this.submitButtonTarget.setAttribute("aria-disabled", !isChecked);
  }

  hasChecked() {
    if (this.hasCheckboxListTarget) {
      return this.hasCheckedCheckboxes();
    } else if (this.hasRadioButtonListTarget) {
      return this.hasCheckedRadioButtons();
    } else {
      return false;
    }
  }

  hasCheckedCheckboxes() {
    const checkboxes = this.checkboxListTarget.querySelectorAll('input[type="checkbox"]');
    return Array.from(checkboxes).some((checkbox) => checkbox.checked && !checkbox.disabled);
  }

  hasCheckedRadioButtons() {
    const radioButtons = this.radioButtonListTarget.querySelectorAll('input[type="radio"]');
    return Array.from(radioButtons).some((radioButton) => radioButton.checked && !radioButton.disabled);
  }
}
